<template>
  <div>
    <b-modal
      :visible="showNewCustomerModal"
      size="xl"
      hide-header
      hide-footer
      cancel-title="Cancelar"
      id="hover-modal"
    >
      <AdminCustomersEditScreen
        :isModal="true"
        id="new"
        @customerAdded="customerAdded"
      />
    </b-modal>

    <ProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') === -1"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></ProductModal>

    <PredefinedProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') >= 0"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></PredefinedProductModal>

    <FreeTextProductModal
      :editData="selectedProductData"
      v-if="showFreeArticleModal"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showFreeArticleModal = false"
    ></FreeTextProductModal>

    <SubtitleModal
      :editData="selectedProductData"
      v-if="showSubtitleModal"
      @addSubtitle="addSubtitle"
      @editSubtitle="editSubtitle"
      @hidden="showSubtitleModal = false"
    ></SubtitleModal>

    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>
            {{ id === 'new' ? 'Nuevo presupuesto' : `Presupuesto ${id}` }}
          </h3>

          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <b-col cols="12">
                <h4>Datos cliente</h4>
              </b-col>
              <b-form-group
                id="input-customer"
                label="Cliente"
                label-for="customer"
                class="col-4"
              >
                <b-form-row>
                  <b-col cols="2">
                    <b-button @click="newCustomerModal" block
                      ><b-icon icon="person-plus-fill" /></b-button
                  ></b-col>

                  <b-col cols="10">
                    <multiselect
                      :multiple="false"
                      track-by="value"
                      @search-change="asyncFindCustomers"
                      @input="customersMultiselectChanged"
                      placeholder=""
                      :options="customersMultiselect.loadedOptions"
                      :loading="customersMultiselect.isLoading"
                      label="text"
                      v-model="$v.form.customer.$model"
                    >
                    </multiselect>

                    <small
                      v-if="$v.form.customer.$error"
                      id="input-customer-feedback"
                      class="invalid-customer text-danger"
                    >
                      Este campo es obligatorio.
                    </small></b-col
                  >
                </b-form-row>
              </b-form-group>

              <b-form-group
                id="input-shippingMethod"
                class="col-4"
                label="Método de envío"
                label-for="shippingMethod"
              >
                <b-form-select
                  :options="shippingMethodSelect.loadedOptions"
                  id="shippingMethod"
                  v-model="$v.form.shippingMethod.$model"
                  @change="shippingMethodChanged"
                  :state="validateState('shippingMethod')"
                  aria-describedby="input-shippingMethod-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-shippingMethod-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-shippingAddress"
                class="col-4"
                label="Dirección de envío"
                label-for="shippingAddress"
              >
                <b-form-select
                  :options="shippingAddressSelect.loadedOptions"
                  :disabled="
                    ![3, 4, 5, 6, 7].includes($v.form.shippingMethod.$model)
                  "
                  id="shippingAddress"
                  v-model="$v.form.shippingAddress.$model"
                  :state="validateState('shippingAddress')"
                  aria-describedby="input-shippingAddress-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-shippingAddress-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-location"
                class="col-3"
                label="Tienda"
                label-for="location"
              >
                <b-form-select
                  :options="locationSelect.loadedOptions"
                  id="location"
                  disabled
                  v-model="$v.form.location.$model"
                  :state="validateState('location')"
                  aria-describedby="input-location-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-location-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-discountType"
                class="col-2"
                label="Tipo de descuento"
                label-for="discountType"
              >
                <b-form-select
                  :options="discountTypeSelect.options"
                  id="discountType"
                  v-model="$v.form.discountType.$model"
                  @change="discountTypeChanged"
                  aria-describedby="input-discountType"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                class="col-3"
                id="input-manual_numeration"
                label="Numeración"
                label-for="manual_numeration"
                description="Se mostrará en la factura en lugar del ID de presupuesto"
              >
                <b-form-input
                  id="manual_numeration"
                  v-model="$v.form.manual_numeration.$model"
                  :state="validateState('manual_numeration')"
                  aria-describedby="input-manual_numeration-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-manual_numeration-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-billingAddress"
                class="col-3"
                label="Dirección de facturación"
                label-for="billingAddress"
                description="El presupuesto contendrá los datos identificativos de la dirección seleccionada en lugar del cliente al cual va dirigido"
              >
                <b-input-group>
                  <b-form-select
                    :options="billingAddressSelect.loadedOptions"
                    id="billingAddress"
                    @change="billingAddressSelectChanged"
                    v-model="$v.form.billingAddress.$model"
                    :state="validateState('billingAddress')"
                    aria-describedby="input-billingAddress-feedback"
                  ></b-form-select>

                  <b-form-invalid-feedback id="input-billingAddress-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                  <b-input-group-append>
                    <b-button
                      @click="clearBillingAddress"
                      variant="outline-danger"
                    >
                      <b-icon icon="x" aria-hidden="true"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-card
                  class="mt-2"
                  v-if="this.billingAddressSelect.selectedAddress"
                >
                  <span
                    :key="i"
                    v-for="(v, i) in $options.filters.formatBillingAddress(
                      this.billingAddressSelect.selectedAddress
                    )"
                  >
                    {{ v }}<br />
                  </span>
                </b-card>
              </b-form-group>

              <b-form-group
                id="input-created_by"
                class="col-3"
                label="Creado por"
                label-for="created_by"
              >
                <multiselect
                  :multiple="true"
                  track-by="value"
                  placeholder=""
                  :options="employeeProfileMultiSelect.loadedOptions"
                  :loading="employeeProfileMultiSelect.isLoading"
                  label="text"
                  v-model="$v.form.created_by.$model"
                >
                </multiselect>

                <!-- <b-form-select
                  :options="employeeProfileMultiSelect.loadedOptions"
                  id="created_by"
                  v-model="$v.form.created_by.$model"
                  :state="validateState('created_by')"
                  aria-describedby="input-created_by-feedback"
                ></b-form-select> -->

                <b-form-invalid-feedback id="input-created_by-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-saleType"
                class="col-2"
                label="Tipo de venta"
                label-for="saleType"
              >
                <b-form-select
                  :options="saleTypeSelect.options"
                  id="saleType"
                  v-model="$v.form.saleType.$model"
                  @change="saleTypeChanged"
                  aria-describedby="input-saleType"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-incotermType"
                class="col-2"
                label="Incoterm"
                label-for="incotermType"
              >
                <b-form-select
                  :disabled="incotermTypeSelect.disabled"
                  :options="incotermTypeSelect.options"
                  id="incotermType"
                  :state="validateState('incotermType')"
                  v-model="$v.form.incotermType.$model"
                  @change="incotermTypeChanged"
                  aria-describedby="input-incotermType-feedback"
                ></b-form-select>

                <b-form-invalid-feedback id="input-incotermType-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row class="pb-3">
              <b-col cols="12">
                <h4>Artículos</h4>
              </b-col>
              <b-col :cols="6">
                <multiselect
                  track-by="value"
                  @search-change="asyncFindProducts"
                  placeholder=""
                  :options="productsMultiselect.loadedOptions"
                  :loading="productsMultiselect.isLoading"
                  :internal-search="false"
                  :options-limit="50"
                  label="text"
                  v-model="form.product"
                >
                </multiselect
              ></b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="!this.form.customer || !form.shippingMethod"
                  @click="addArticleToQuoteBtn"
                  >Añadir a presupuesto</b-button
                >
              </b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="!this.form.customer || !form.shippingMethod"
                  @click="addFreeTextArticleToQuoteBtn"
                  >Añadir línea libre</b-button
                >
              </b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  :disabled="!this.form.customer || !form.shippingMethod"
                  @click="addSubtitleToQuoteBtn"
                  >Añadir subtítulo (grupos)</b-button
                >
              </b-col>
            </b-form-row>

            <div
              v-if="
                form.products.length > 0 && form.productPricesInclTax.length > 0
              "
            >
              <hr />
              <b-form-row>
                <b-form-group class="col-2"> Imagen </b-form-group>
                <b-form-group
                  :class="
                    $v.form.discountType.$model === 'Total' ? 'col-6' : 'col-4'
                  "
                >
                  Nombre
                </b-form-group>
                <b-form-group class="col-1"> Unidades </b-form-group>
                <!--<b-form-group class="col-1"> Precio </b-form-group>-->
                <b-form-group class="col-1"> Subtotal </b-form-group>
                <b-form-group
                  v-if="$v.form.discountType.$model !== 'Total'"
                  class="col-2"
                >
                  Descuento
                </b-form-group>
                <!--<b-form-group class="col-1"> Suplemento </b-form-group>-->
                <b-form-group class="col-1"> </b-form-group>
              </b-form-row>

              <div
                :key="i"
                v-for="(product, i) in $v.form.products.$each.$iter"
              >
                <b-form-row v-if="!['subtitle'].includes(product.type.$model)">
                  <b-col cols="2">
                    <div style="position: relative; width: 100%; height: 100%">
                      <img
                        v-bind:class="{
                          uniqueImg:
                            Object.keys(product.images.$each.$iter).length ===
                            1,
                          leftImg:
                            Object.keys(product.images.$each.$iter).length ===
                              2 && index === 0,
                          rightImg:
                            Object.keys(product.images.$each.$iter).length ===
                              2 && index === 1,
                        }"
                        :src="image"
                        v-for="(image, index) in orderedProductImagesArr(
                          product.images.$each.$iter
                        )"
                        :key="index"
                      />
                    </div>
                    <!-- <div
                      v-for="(image, index) in product.images.$each.$iter"
                      :key="index"
                    >
                      <img
                        v-bind:src="'data:image/jpeg;base64,' + `${image}`"
                      />
                    </div> -->
                  </b-col>

                  <b-form-group
                    :class="
                      $v.form.discountType.$model === 'Total'
                        ? 'col-6'
                        : 'col-4'
                    "
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-input-group>
                          <b-form-input
                            :disabled="true"
                            :value="product.reference.$model"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              v-if="i > 0"
                              variant="outline-primary"
                              size="sm"
                              @click="moveUp(i)"
                            >
                              <b-icon icon="arrow-up"></b-icon>
                            </b-button>

                            <b-button
                              v-if="i < form.products.length - 1"
                              variant="outline-primary"
                              size="sm"
                              @click="moveDown(i)"
                            >
                              <b-icon icon="arrow-down"></b-icon>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col cols="12">
                        <ul v-if="product.type.$model !== 'free'">
                          <li
                            :key="j"
                            v-for="(attribute, j) in product.attributes.$each
                              .$iter"
                          >
                            {{ attribute.label.$model }} :
                            {{ attribute.selector_inputs.$model.name }}
                          </li>
                          <li v-if="product.comments.$model" class="comments">
                            Comentarios:
                            <span style="white-space: pre">{{
                              product.comments.$model
                            }}</span>
                          </li>
                        </ul>
                        <ul v-else>
                          <li>
                            {{ product.description.$model }}
                          </li>
                          <li v-if="product.comments.$model" class="comments">
                            Comentarios:
                            <span style="white-space: pre">{{
                              product.comments.$model
                            }}</span>
                          </li>
                        </ul></b-col
                      >
                    </b-row>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-row>
                      <b-col cols="12">
                        <b-form-input
                          type="text"
                          :value="
                            product.quantity.$model.toString().replace('.', ',')
                          "
                          @change="setDecimalProduct(i, 'quantity', $event)"
                        ></b-form-input>
                      </b-col>
                      <b-col
                        cols="12"
                        :class="
                          isStockAvailable(i)
                            ? 'stock text-success'
                            : 'stock text-danger'
                        "
                        >En stock: {{ getStockInfo(i) }}</b-col
                      >
                    </b-row>
                  </b-form-group>

                  <b-form-group class="col-1">
                    <b-form-input
                      type="number"
                      :step="0.01"
                      :disabled="true"
                      :aria-describedby="'input-products-subtotal-' + i"
                      :value="
                        form.productPricesExclTax[i]
                          ? form.productPricesExclTax[i].toFixed(2)
                          : form.productPricesExclTax[i]
                      "
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        id="productDiscount"
                        :value="form.productDiscounts[i]"
                        @change="changeProductDiscount(i, $event)"
                        :aria-describedby="
                          'input-productDiscounts-subtotal-' + i
                        "
                      ></b-form-input>
                      <template #append>
                        <b-input-group-text>%</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    v-if="$v.form.discountType.$model !== 'Total'"
                    class="col-1"
                  >
                    <b-input-group>
                      <b-form-input
                        :disabled="true"
                        :value="form.productDiscountsAbsolute[i]"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group>
                    <b-button-group>
                      <b-button
                        @click="editArticle(i)"
                        variant="outline-primary"
                        ><b-icon icon="pencil"></b-icon
                      ></b-button>
                      <b-button
                        @click="duplicateArticle(i)"
                        variant="outline-primary"
                        ><b-icon icon="files"></b-icon
                      ></b-button>
                      <b-button
                        @click="deleteArticle(i)"
                        variant="outline-danger"
                        ><b-icon icon="trash"></b-icon
                      ></b-button>
                    </b-button-group>
                  </b-form-group>
                </b-form-row>
                <b-form-row v-else>
                  <b-col class="subtitle mb-4" :cols="12">
                    {{ product.subtitle.$model }}
                  </b-col>
                </b-form-row>
              </div>
              <hr />

              <b-form-row>
                <b-form-group class="col-1"> </b-form-group>
                <b-form-group class="col-6"> </b-form-group>
                <b-form-group class="col-1"> </b-form-group>
                <b-col :cols="3">
                  <b-row>
                    <b-col :cols="5">SUBTOTAL</b-col>
                    <b-col :cols="7"
                      >{{ form.totalPriceProductsExclTax.toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row align-v="center">
                    <b-col :cols="5">DESCUENTO</b-col>
                    <b-col :cols="3">-{{ form.discount.toFixed(2) }} €</b-col>
                    <b-col
                      :cols="4"
                      v-if="$v.form.discountType.$model === 'Total'"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          id="discountPct"
                          :value="$v.form.discountPct.$model.replace('.', ',')"
                          @change="
                            setDecimal('discountPct', $event);
                            changedDiscount();
                          "
                          :state="validateState('discountPct')"
                          aria-describedby="input-discountPct-feedback"
                        ></b-form-input>
                        <template #append>
                          <b-input-group-text>%</b-input-group-text>
                        </template>
                      </b-input-group></b-col
                    >
                  </b-row>

                  <b-row
                    class="mt-1 mb-1"
                    v-if="form.shippingMethod === 6"
                    align-v="center"
                  >
                    <b-col :cols="5">ENVÍO</b-col>
                    <b-col :cols="3"
                      >{{ parseFloat(form.shippingPrice).toFixed(2) }} €</b-col
                    >
                    <b-col :cols="4">
                      <b-input-group size="sm">
                        <b-form-input
                          id="shippingPrice"
                          :value="form.shippingPrice.replace('.', ',')"
                          @change="freeShippingChanged"
                          :state="validateState('shippingPrice')"
                          aria-describedby="input-shippingPrice-feedback"
                        ></b-form-input>

                        <template #append>
                          <b-input-group-text>€</b-input-group-text>
                        </template>
                      </b-input-group></b-col
                    >
                  </b-row>
                  <b-row v-else>
                    <b-col :cols="5">ENVÍO</b-col>
                    <b-col :cols="7">{{ form.shippingPrice }} €</b-col>
                  </b-row>
                  <b-row align-v="center">
                    <b-col :cols="5">{{ taxName }}</b-col>
                    <b-col :cols="7"
                      >{{ parseFloat(form.taxPrice).toFixed(2) }} €</b-col
                    >
                  </b-row>

                  <b-row>
                    <b-col :cols="5"><strong>TOTAL</strong></b-col>
                    <b-col :cols="7"
                      ><strong>{{ totalPrice.toFixed(2) }} €</strong></b-col
                    >
                  </b-row>
                  <b-row class="mt-2">
                    <b-col :cols="12">Pagar con:</b-col>
                    <b-col :cols="12">
                      <b-button-group style="width: 100%">
                        <b-button
                          style="width: 33.33%"
                          @click="payWithCredit()"
                          variant="outline-primary"
                          size="sm"
                          ><b-icon icon="credit-card"></b-icon> Tarjeta
                          crédito</b-button
                        >
                        <b-button
                          style="width: 33.33%"
                          @click="payWithTransfer()"
                          variant="outline-primary"
                          size="sm"
                          ><b-icon icon="bank2"></b-icon>
                          Transferencia</b-button
                        >
                        <b-button
                          style="width: 33.33%"
                          @click="payWithCash()"
                          size="sm"
                          variant="outline-primary"
                          ><b-icon icon="cash-coin"></b-icon> Efectivo</b-button
                        >
                      </b-button-group>
                    </b-col>
                    <b-col cols="12">
                      <b-input-group>
                        <b-form-input
                          :value="form.amtPaidCredit"
                          @change="setDecimal('amtPaidCredit', $event)"
                        ></b-form-input>

                        <b-form-input
                          :value="form.amtPaidTransfer"
                          @change="setDecimal('amtPaidTransfer', $event)"
                        ></b-form-input>

                        <b-form-input
                          :value="form.amtPaidCash"
                          @change="setDecimal('amtPaidCash', $event)"
                        ></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-1">
                    <b-col
                      v-if="
                        parseFloat(pendingAmt.toFixed(2)) > 0.0 ||
                        parseFloat(pendingAmt.toFixed(2)) < 0.0
                      "
                      :cols="12"
                      class="text-danger"
                      >Pendiente: {{ pendingAmt.toFixed(2) }} €</b-col
                    >
                    <b-col v-else class="text-success">Pendiente: 0.00 €</b-col>
                  </b-row>
                </b-col>
              </b-form-row>
            </div>

            <b-form-row class="mt-2">
              <b-col :cols="12">
                <b-row>
                  <b-col
                    v-if="id !== 'new' && workshopOrders.length > 0"
                    :cols="4"
                  >
                    <b-button
                      :disabled="syncingOrder"
                      v-for="workshopOrderId in workshopOrders"
                      :key="workshopOrderId"
                      variant="outline-primary"
                      @click="syncOrder(workshopOrderId)"
                      block
                      type="submit"
                    >
                      {{
                        syncingOrder
                          ? 'Sincronizando pedido '
                          : 'Sincronizar pedido '
                      }}
                      #{{ workshopOrderId }}</b-button
                    >

                    <small class="gray-text mt-1"
                      >Pedidos que se crearon a partir del presupuesto. Al
                      sincronizar un pedido, se vuelcan los datos del
                      presupuesto (productos, método de envío, descuentos,
                      precios...) en el pedido, de forma que las órdenes de
                      taller y/o facturas englobarán la totalidad de los
                      productos del presupuesto.
                      <strong
                        >Recuerda haber guardado el presupuesto antes de
                        sincronizar un pedido, pues sólo se sincronizan los
                        datos guardados, no necesariamente los que hay en
                        pantalla.</strong
                      >
                    </small>
                  </b-col>
                  <b-col
                    :cols="id === 'new' || workshopOrders.length == 0 ? 6 : 4"
                  >
                    <b-button variant="outline-primary" block type="submit">
                      {{
                        id !== 'new'
                          ? 'Guardar presupuesto'
                          : 'Guardar nuevo presupuesto'
                      }}</b-button
                    >

                    <small class="gray-text mt-1"
                      >Para editarlo más adelante. Podrás acceder a él desde el
                      menú, apartado de
                      <b-link
                        :to="{
                          name: 'AdminQuotesScreen',
                          params: { location: this.form.location },
                        }"
                      >
                        Presupuestos</b-link
                      ></small
                    >
                  </b-col>
                  <b-col
                    :cols="id === 'new' || workshopOrders.length == 0 ? 6 : 4"
                  >
                    <b-button variant="primary" block @click="markAsPaid()">
                      Guardar presupuesto y generar pedido</b-button
                    >

                    <small class="gray-text mt-1"
                      ><strong>Recuerda</strong>, antes de formalizar el pedido,
                      comprueba que el presupuesto haya sido pagado en su
                      totalidad.
                      <!-- <ol>
                        <li>
                          revisa el stock de productos para saber cuál/es
                          puede/n entregarse ya y cuál/es se fabricarán en el
                          taller
                        </li>
                        <li>
                          comprueba que el presupuesto haya sido pagado en su
                          totalidad
                        </li>
                      </ol> -->
                    </small>
                  </b-col>
                </b-row>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/quotes/ProductModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import moment from 'moment';

import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';
import SubtitleModal from '@/admin/components/quotes/SubtitleModal.vue';

import AdminCustomersEditScreen from '@/admin/screens/customers/AdminCustomersEditScreen.vue';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AdminQuotesEditScreen',
  props: ['id', 'location'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    FreeTextProductModal,
    AdminCustomersEditScreen,
    SubtitleModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      customer: {
        required,
      },
      billingAddress: {},
      shippingMethod: {
        required,
      },
      created_by: {},
      location: {
        required,
      },
      shippingAddress: {},
      manual_numeration: {},
      productPricesInclTax: {
        required,
      },
      productPricesExclTax: {
        required,
      },
      productDiscounts: {},
      productDiscountsAbsolute: {},
      discountType: {
        required,
      },
      saleType: {
        required,
      },
      incotermType: {
        required,
      },
      discount: {
        required,
      },
      discountPct: {
        required,
      },
      totalPriceProductsInclTax: {
        required,
      },
      totalPriceProductsExclTax: {
        required,
      },
      shippingPrice: {
        required,
      },
      taxPrice: {
        required,
      },

      amtPaidCredit: {
        required,
      },
      amtPaidTransfer: {
        required,
      },
      amtPaidCash: {
        required,
      },
      products: {
        $each: {
          reference: {
            required,
          },
          attributes: {
            $each: {
              selector_inputs: {
                required,
              },
              extra_info: {},
              label: {
                required,
              },
              reference: {
                // Empty for predefined products
              },
            },
          },
          description: {},
          comments: {},
          subtitle: {},
          images: {
            $each: {},
          },
          quantity: {
            required,
          },
          type: {
            required,
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      customer: null,
      billingAddress: null,
      shippingMethod: null,
      created_by: null,
      location: null,
      shippingAddress: null,
      product: null,
      manual_numeration: null,
      products: [],
      productPricesInclTax: [],
      productPricesExclTax: [],
      productDiscounts: [],
      productDiscountsAbsolute: [],
      discountType: 'Total',
      saleType: 'national',
      incotermType: null,
      discount: 0.0,
      discountTax: 0.0,
      discountPct: '0.0',
      totalPriceProductsInclTax: 0.0,
      totalPriceProductsExclTax: 0.0,

      created_by: [],
      shippingPrice: '0.0',
      shippingPriceInclTax: '0.0',
      taxPrice: 0.0,
      productHashes: [],
      productStocks: [],
      productsPartiallyAvailableStockCanBeResused: [],

      amtPaidCredit: '0.0',
      amtPaidTransfer: '0.0',
      amtPaidCash: '0.0',
      // password: '',
      // password_confirmation: '',
      error: {
        show: false,
        text: '',
      },
    };

    return {
      syncingOrder: false,
      workshopOrders: [],
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
      customersMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },
      productsMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },
      employeeProfileMultiSelect: {
        loadedOptions: [],
        isLoading: false,
      },
      billingAddressSelect: {
        loadedOptions: [],
        selectedAddress: null,
      },
      shippingMethodSelect: {
        loadedOptions: [],
      },
      employeeProfileSelect: {
        loadedOptions: [],
      },
      locationSelect: {
        loadedOptions: [],
      },
      shippingAddressSelect: {
        loadedOptions: [],
      },
      discountTypeSelect: {
        options: [
          { text: 'Global', value: 'Total' },
          { text: 'Por producto', value: 'Per-product' },
        ],
      },
      saleTypeSelect: {
        options: [
          { text: 'Nacional', value: 'national' },
          { text: 'Intracomunitaria', value: 'intra-community' },
          { text: 'Exportación', value: 'export' },
          { text: 'Canarias', value: 'canary' },
          { text: 'Ceuta/Melilla', value: 'ceuta-melilla' },
        ],
      },
      incotermTypeSelect: {
        disabled: false,
        options: [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ],
      },
      selectedProductID: null,
      selectedProductData: null,
      showModal: false,
      showFreeArticleModal: false,
      showSubtitleModal: false,
      showNewCustomerModal: false,
    };
  },
  computed: {
    pendingAmt() {
      return (
        this.totalPrice -
        parseFloat(this.form.amtPaidCredit ? this.form.amtPaidCredit : '0.00') -
        parseFloat(
          this.form.amtPaidTransfer ? this.form.amtPaidTransfer : '0.00'
        ) -
        parseFloat(this.form.amtPaidCash ? this.form.amtPaidCash : '0.00')
      );
    },
    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discountTax) +
        parseFloat(this.form.shippingPriceInclTax)
      );
    },
    taxName() {
      // if (this.form.saleType == 'canary') {
      //   return 'IGIC';
      // } else if (this.form.saleType == 'ceuta-melilla') {
      //   return 'IPSI';
      // }
      return 'IVA';
    },
  },
  created() {
    // this.productsMultiselect.isLoading = true;
    this.customersMultiselect.isLoading = true;

    let promises = [];
    promises.push(actions.getShippingMethodsUnpaginated());
    promises.push(actions.getCustomersUnpaginated());
    promises.push(actions.getProductsUnpaginated());
    promises.push(actions.getPredefinedProductsUnpaginated());
    promises.push(actions.getLocationsUnpaginated());
    promises.push(actions.getEmployees());

    Promise.all(promises).then((x) => {
      this.shippingMethodSelect.loadedOptions = x[0].data.results.map((x) => {
        return {
          text: x.name + (x.id === 6 ? ' (libre)' : ' (' + x.cost + ' €)'),
          value: x.id,
          cost: x.cost,
        };
      });

      this.customersMultiselect.loadedOptions = x[1].data.results.map((x) => {
        return {
          text: x.full_name + (x.email ? ' (' + x.email + ')' : ''),
          value: x.id,
          default_discount: x.default_discount,
          email: x.email ? x.email : '',
        };
      });
      this.customersMultiselect.isLoading = false;

      this.productsMultiselect.loadedOptions = x[2].data.results.map((x) => {
        return {
          text: '(' + x.id + ') ' + x.reference,
          value: x.id,
        };
      });

      this.productsMultiselect.loadedOptions = [
        ...this.productsMultiselect.loadedOptions,
        ...x[3].data.results.map((x) => {
          return {
            text: '(' + x.id + ') ' + x.reference,
            value: 'PRE_' + x.id,
          };
        }),
        ,
      ];

      // Location
      this.locationSelect.loadedOptions = x[4].data.results.map((x) => {
        return {
          text: x.name,
          value: x.id,
        };
      });

      this.form.location = this.location;

      // Employees
      this.employeeProfileMultiSelect.loadedOptions = x[5].data.results.map(
        (x) => {
          return {
            text: x.first_name + ' ' + x.last_name,
            value: x.id,
            works_here_today: x.workschedule_set.some(
              (xxx) =>
                xxx.day_of_week === moment().locale('en').format('dddd') &&
                xxx.location === this.location
            ),
          };
        }
      );

      const someEmployeeWorkingToday = this.employeeProfileMultiSelect.loadedOptions.filter(
        (xxx) => xxx.works_here_today === true
      );

      // console.log(someEmployeeWorkingToday);

      if (someEmployeeWorkingToday) {
        this.form.created_by = someEmployeeWorkingToday;
      }

      if (this.id !== 'new') {
        actions.getQuote(this.id).then((response2) => {
          const data = response2.data;

          this.form.billingAddress = data.billing_address;
          this.form.shippingAddress = data.shipping_address;
          this.form.shippingMethod = data.shipping_method;
          this.form.created_by = this.employeeProfileMultiSelect.loadedOptions.filter(
            (x) => data.created_by.includes(x.value)
          );
          this.form.products = data.products;
          this.form.shippingPrice = data.shipping_price;
          this.form.shippingPriceInclTax = data.shipping_price_incl_tax;
          this.form.saleType = data.sale_type;
          this.form.incotermType = data.incoterm_type;
          this.form.manual_numeration = data.manual_numeration;

          this.form.productPricesInclTax = data.product_prices_incl_tax;
          this.form.productPricesExclTax = data.product_prices_excl_tax;
          this.form.productDiscounts = data.product_discounts;
          this.form.productDiscountsAbsolute = data.product_discounts_absolute;

          this.workshopOrders = data.workshoporder_set;

          this.form.taxPrice = parseFloat(data.tax_price);

          this.form.discountPct = data.discount_pct;
          this.form.discount = parseFloat(data.discount);
          this.form.discountTax = parseFloat(data.discount_tax);
          this.form.discountType = data.discount_type;

          this.form.amtPaidCredit = data.amt_paid_credit;
          this.form.amtPaidTransfer = data.amt_paid_transfer;
          this.form.amtPaidCash = data.amt_paid_cash;

          this.form.location = data.location;

          this.form.totalPriceProductsInclTax = parseFloat(
            data.totalprice_products_incl_tax
          );

          this.form.totalPriceProductsExclTax = parseFloat(
            data.totalprice_products_excl_tax
          );

          this.form.productHashes = data.product_hashes;
          this.form.productStocks = data.product_stocks;
          this.form.productsPartiallyAvailableStockCanBeResused =
            data.product_partially_stocks_can_be_reused;

          this.location = data.location;
          this.form.location = this.location;

          this.updateAvailableIncotermTypes();

          // Force update stock

          actions.getCustomer(data.customer).then((response3) => {
            const data = response3.data;

            this.form.customer = this.customersMultiselect.loadedOptions.find(
              (x) => x.value === data.id
            );

            this.quoteStock();
          });

          actions
            .getBillingAddressesByCustomer(data.customer, 0)
            .then((response5) => {
              this.billingAddressSelect.loadedOptions = response5.data.results.map(
                (x) => {
                  return {
                    text: x.name,
                    value: x.id,
                  };
                }
              );

              if (this.form.billingAddress) {
                this.billingAddressSelectChanged(
                  this.billingAddressSelect.loadedOptions.find(
                    (yy) => yy.value === this.form.billingAddress
                  ).value
                );
              }
            });

          actions
            .getShippingAddressesByCustomer(data.customer)
            .then((response4) => {
              this.shippingAddressSelect.loadedOptions = response4.data.results.map(
                (x) => {
                  return {
                    text: x.name,
                    value: x.id,
                  };
                }
              );
            });
        });
      }
    });
  },
  filters: {
    formatBillingAddress: function (billingAddress) {
      const {
        full_name,
        street_address,
        street_address_2,
        urbanization,
        postal_code,
        city,
        country,
        country_name,
        company_id,
      } = billingAddress;

      let lines = [];
      if (full_name) lines.push(`${full_name}`);

      if (company_id) lines.push(`${company_id}`);

      if (street_address) lines.push(`${street_address}`);

      if (street_address_2) lines.push(`${street_address_2}`);

      if (urbanization) lines.push(`${urbanization}`);

      if (city) lines.push(`${city} (${postal_code})`);

      if (country_name) lines.push(`${country_name}`);

      return lines;
    },
  },
  methods: {
    updateAvailableIncotermTypes() {
      if (
        [1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['national', 'intra-community', 'canary', 'ceuta-melilla'].includes(
          this.$v.form.saleType.$model
        )
      ) {
        this.$v.form.incotermType.$model = 'EXW';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        ![1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['national', 'intra-community', 'canary', 'ceuta-melilla'].includes(
          this.$v.form.saleType.$model
        )
      ) {
        this.$v.form.incotermType.$model = 'DDP';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        [1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['export'].includes(this.$v.form.saleType.$model)
      ) {
        this.$v.form.incotermType.$model = 'EXW';
        this.incotermTypeSelect.disabled = true;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
          { text: 'EXW', value: 'EXW' },
        ];
        // this.incotermTypeSelect.find(x => ['DDP','DAP'].includes(x.value))
      } else if (
        ![1, 2].includes(this.$v.form.shippingMethod.$model) &&
        ['export'].includes(this.$v.form.saleType.$model)
      ) {
        this.$v.form.incotermType.$model = 'DDP';
        this.incotermTypeSelect.disabled = false;
        this.incotermTypeSelect.options = [
          { text: 'DDP', value: 'DDP' },
          { text: 'DAP', value: 'DAP' },
        ];
      }
    },
    freeShippingChanged(val) {
      this.setDecimal('shippingPrice', val);
      this.quotePrice();
    },
    clearBillingAddress() {
      this.form.billingAddress = null;
      this.billingAddressSelect.selectedAddress = null;
      this.$v.form['billingAddress'].$touch();
    },
    syncOrder(orderId) {
      this.syncingOrder = true;

      let that = this;
      setTimeout(() => {
        actions
          .postWorkshopOrderSyncFromQuote(orderId, { quote_id: this.id })
          .then(() => {
            that.syncingOrder = false;
          });
      }, 1000);
    },
    payWithCredit() {
      this.form.amtPaidCredit = this.totalPrice.toFixed(2);
      this.form.amtPaidTransfer = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithTransfer() {
      this.form.amtPaidTransfer = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithCash() {
      this.form.amtPaidCash = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidTransfer = '0.0';
    },
    isStockAvailable(i) {
      let availableStock = this.form.productStocks[i][this.location];
      let productQuantity = this.form.products[i].quantity;

      return availableStock >= productQuantity;
    },
    getStockInfo(i) {
      let availableStock = this.form.productStocks[i][this.location];
      let productQuantity = this.form.products[i].quantity;

      const partiallyStockCanBeReused = this.form
        .productsPartiallyAvailableStockCanBeResused[i];

      if (productQuantity > availableStock) {
        if (availableStock <= 0) {
          return `${availableStock}\nA fabricar: ${productQuantity}`;
        } else if (partiallyStockCanBeReused) {
          return `${availableStock}\nA fabricar: ${
            productQuantity - availableStock
          }`;
        } else {
          return `${availableStock}\nA fabricar: ${productQuantity} (producto con stock parcial no reaprovechable)`;
        }
      }

      return `${availableStock}`;
    },
    changeProductDiscount(i, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.form.productDiscounts[i] = val;

      this.quotePrice();
    },
    swapProducts(i, j) {
      this.form.products[i] = this.form.products.splice(
        j,
        1,
        this.form.products[i]
      )[0];
      this.form.productPricesInclTax[i] = this.form.productPricesInclTax.splice(
        j,
        1,
        this.form.productPricesInclTax[i]
      )[0];
      this.form.productPricesExclTax[i] = this.form.productPricesExclTax.splice(
        j,
        1,
        this.form.productPricesExclTax[i]
      )[0];

      this.form.productHashes[i] = this.form.productHashes.splice(
        j,
        1,
        this.form.productHashes[i]
      )[0];

      this.form.productStocks[i] = this.form.productStocks.splice(
        j,
        1,
        this.form.productStocks[i]
      )[0];

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts[i] = this.form.productDiscounts.splice(
          j,
          1,
          this.form.productDiscounts[i]
        )[0];

        this.form.productDiscountsAbsolute[
          i
        ] = this.form.productDiscountsAbsolute.splice(
          j,
          1,
          this.form.productDiscountsAbsolute[i]
        )[0];
      }
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapProducts(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapProducts(i, i + 1);
    },
    orderedProductImagesArr(productImages) {
      let arr = [];
      for (let index = 0; index < Object.keys(productImages).length; index++) {
        const element = Object.keys(productImages).reverse()[index];
        arr.push(productImages[element].$model);
      }
      return arr;
    },
    markAsPaid() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let data = this.getFormData();

      if (this.id !== 'new') {
        actions.patchQuote(this.id, data).then(() => {
          actions.postQuoteMarkPaid(this.id).then((response) => {
            if (this.sharedState.auth.role === 'full') {
              this.$router.push({
                name: 'AdminWorkshopOrdersEditScreen',
                params: { id: response.data.workshop_order_id },
              });
            } else {
              this.$router.push({
                name: 'AdminQuotesScreen',
                params: { location: this.form.location },
              });
            }
          });
        });
      } else {
        actions.postQuote(data).then((x) => {
          actions.postQuoteMarkPaid(x.data.id).then((response) => {
            if (this.sharedState.auth.role === 'full') {
              this.$router.push({
                name: 'AdminWorkshopOrdersEditScreen',
                params: { id: response.data.workshop_order_id },
              });
            } else {
              this.$router.push({
                name: 'AdminQuotesScreen',
                params: { location: this.form.location },
              });
            }
          });
        });
      }
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.quotePrice();
    },
    customerAdded(idCustomer) {
      actions.getCustomersUnpaginated().then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text: x.full_name + (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
            };
          }
        );

        this.customersMultiselect.isLoading = false;
        this.form.customer = this.customersMultiselect.loadedOptions.find(
          (x) => x.value === idCustomer
        );
        this.showNewCustomerModal = false;
      });
    },
    newCustomerModal() {
      this.showNewCustomerModal = true;
    },

    changedDiscount() {
      if (!this.form.shippingMethod) {
        return false;
      }
      this.quotePrice(false /*, true*/);
    },
    quoteStock() {
      let data = {};

      data['customer'] = this.form.customer.value;
      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      actions.postQuotePrice(data).then((x) => {
        this.form.productHashes = x.data.productHashes;
        this.form.productStocks = x.data.productStockAvailability;
        this.form.productsPartiallyAvailableStockCanBeResused =
          x.data.productsPartiallyAvailableStockCanBeResused;
      });
    },
    quotePrice(
      onlyUpdateShippingPrice = false /*, onlyUpdateDiscount = false*/
    ) {
      let data = {};

      data['customer'] = this.form.customer ? this.form.customer.value : null;

      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      data['sale_type'] = this.form.saleType;

      if (this.$v.form.shippingMethod.$model === 6) {
        data['shipping_price'] = this.form.shippingPrice;
      }

      actions.postQuotePrice(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        if (!onlyUpdateShippingPrice) {
          this.form.productPricesInclTax = x.data.productPricesInclTax;
          this.form.productPricesExclTax = x.data.productPricesExclTax;
          this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

          this.form.discount = x.data.discount;
          this.form.discountTax = x.data.discountTax;

          this.form.totalPriceProductsInclTax =
            x.data.totalPriceProductsInclTax;

          this.form.totalPriceProductsExclTax =
            x.data.totalPriceProductsExclTax;

          this.form.taxPrice = x.data.taxPrice;

          this.form.productHashes = x.data.productHashes;
          this.form.productStocks = x.data.productStockAvailability;
          this.form.productsPartiallyAvailableStockCanBeResused =
            x.data.productsPartiallyAvailableStockCanBeResused;

          this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          this.form.shippingPriceInclTax = x.data.shippingPriceInclTax.toFixed(
            2
          );
        } else {
          this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          this.form.shippingPriceInclTax = x.data.shippingPriceInclTax.toFixed(
            2
          );
        }
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editSubtitle(subtitle) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        subtitle: subtitle,
        type: 'subtitle',
      });

      this.showSubtitleModal = false;
    },
    editProduct(productData, attributes, currentPrice, qty, comments, images) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        reference: productData.reference,
        // attributes: attributes.map((x, i) => {
        //   return {
        //     name: x.label,
        //     txtValue: x.selector_inputs.name,
        //     value: x.selector_inputs.value,
        //   };
        // }),
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();

      this.showFreeArticleModal = false;

      this.showModal = false;
    },
    addSubtitle(subtitle) {
      this.showSubtitleModal = false;

      this.form.products.push({
        subtitle: subtitle,
        type: 'subtitle',
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },
    addProduct(productData, attributes, currentPrice, qty, comments, images) {
      this.showModal = false;
      this.showFreeArticleModal = false;

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts.push('0');
        this.form.productDiscountsAbsolute.push('0');
      }

      this.form.products.push({
        reference: productData.reference,

        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },
    deleteArticle(articleIndex) {
      const name = this.form.products[articleIndex].reference;

      if (
        confirm(
          '¿Estás seguro que deseas quitar el producto ' +
            name +
            ' del presupuesto?'
        )
      ) {
        this.form.products.splice(articleIndex, 1);
        this.form.productDiscounts.splice(articleIndex, 1);
        this.form.productDiscountsAbsolute.splice(articleIndex, 1);

        this.quotePrice();
      }
    },
    editArticle(articleIndex) {
      //if ()
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },
    duplicateArticle(articleIndex) {
      const newProduct = JSON.parse(
        JSON.stringify(this.form.products[articleIndex])
      );

      this.form.products.splice(articleIndex, 0, newProduct);

      this.form.productPricesInclTax.splice(
        articleIndex,
        0,
        this.form.productPricesInclTax[articleIndex]
      );

      this.form.productPricesExclTax.splice(
        articleIndex,
        0,
        this.form.productPricesExclTax[articleIndex]
      );

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts.splice(
          articleIndex,
          0,
          this.form.productDiscounts[articleIndex]
        );

        this.form.productDiscountsAbsolute.splice(
          articleIndex,
          0,
          this.form.productDiscountsAbsolute[articleIndex]
        );
      }

      this.quotePrice();
    },
    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addSubtitleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showSubtitleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();

      this.selectedProductData = null;

      this.showModal = true;
    },
    incotermTypeChanged(val) {
      // if(val=='national'){
      // }
      // else if(val=='intra-community'){
      // }
      // else if(val=='export'){
      // }
      // else if(val=='canary'){
      // }
      // else if(val=='ceuta-melilla'){
      // }
      // this.quotePrice();
    },
    saleTypeChanged(val) {
      this.updateAvailableIncotermTypes();
      // if(val=='national'){

      // }
      // else if(val=='intra-community'){

      // }
      // else if(val=='export'){

      // }
      // else if(val=='canary'){

      // }
      // else if(val=='ceuta-melilla'){

      // }

      this.quotePrice();
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;

        this.form.productDiscounts = [];
        this.form.productDiscountsAbsolute = [];
      }

      this.quotePrice();
    },
    shippingMethodChanged(val) {
      if (![3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model)) {
        this.$v.form.shippingAddress.$model = null;
      } else if (
        [3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model) &&
        this.form.shippingAddress === null &&
        this.shippingAddressSelect.loadedOptions.length > 0
      ) {
        this.$v.form.shippingAddress.$model = this.shippingAddressSelect.loadedOptions[0].value;
      }

      this.quotePrice(true);

      this.updateAvailableIncotermTypes();
    },
    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },
    customersMultiselectChanged(selectedOption, id) {
      this.setDecimal(
        'discountPct',
        selectedOption.default_discount.replace('.', ',')
      );
      this.changedDiscount();

      actions.getBillingAddressesByCustomer(selectedOption.value).then((y) => {
        this.billingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });

      actions.getShippingAddressesByCustomer(selectedOption.value).then((y) => {
        this.shippingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });
    },
    asyncFindCustomers(query) {
      this.customersMultiselect.isLoading = true;
      actions.getCustomersGlobalSearch(query).then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text: x.full_name + (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
              default_discount: x.default_discount,
            };
          }
        );
        this.customersMultiselect.isLoading = false;
      });
    },

    asyncFindProducts(query) {
      this.productsMultiselect.isLoading = true;

      let promises = [];
      promises.push(actions.getProductsGlobalSearch(query));
      promises.push(actions.getPredefinedProductsGlobalSearch(query));

      Promise.all(promises).then((response) => {
        let arr = [];

        arr = [
          ...arr,
          ...response[0].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        arr = [
          ...arr,
          ...response[1].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: 'PRE_' + x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        this.productsMultiselect.loadedOptions = arr;

        this.productsMultiselect.isLoading = false;
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },
    getFormData() {
      let data = {};

      data['customer'] = this.form.customer.value;
      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['created_by'] = this.form.created_by.map((x) => x.value);
      data['products'] = this.form.products;

      data['manual_numeration'] = this.form.manual_numeration;

      data['product_prices_incl_tax'] = this.form.productPricesInclTax;
      data['product_discounts'] = this.form.productDiscounts;
      data['product_discounts_absolute'] = this.form.productDiscountsAbsolute;
      data['discount_type'] = this.form.discountType;

      data['product_prices_excl_tax'] = this.form.productPricesExclTax;

      data['discount_pct'] = this.form.discountPct;
      data['discount'] = this.form.discount.toFixed(4);
      data['discount_tax'] = this.form.discountTax.toFixed(4);

      data['tax_price'] = this.form.taxPrice.toFixed(4);

      data[
        'totalprice_products_incl_tax'
      ] = this.form.totalPriceProductsInclTax.toFixed(4);
      data[
        'totalprice_products_excl_tax'
      ] = this.form.totalPriceProductsExclTax.toFixed(4);

      data['product_hashes'] = this.form.productHashes;
      data['product_stocks'] = this.form.productStocks;
      data[
        'product_partially_stocks_can_be_reused'
      ] = this.form.productsPartiallyAvailableStockCanBeResused;

      data['shipping_price'] = this.form.shippingPrice;
      data['shipping_price_incl_tax'] = this.form.shippingPriceInclTax;
      data['sale_type'] = this.form.saleType;

      data['incoterm_type'] = this.form.incotermType;

      data['total_price'] = this.totalPrice.toFixed(2);

      data['location'] = this.form.location;

      data['amt_paid_credit'] = this.form.amtPaidCredit;
      data['amt_paid_transfer'] = this.form.amtPaidTransfer;
      data['amt_paid_cash'] = this.form.amtPaidCash;
      data['amt_paid'] = this.totalPrice.toFixed(2);

      return data;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = this.getFormData();

      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        actions.patchQuote(this.id, data).then((x) => {
          this.$router.push({
            name: 'AdminQuotesScreen',
            params: { location: this.form.location },
          });
        });
      } else {
        actions.postQuote(data).then((x) => {
          this.$router.push({
            name: 'AdminQuotesScreen',
            params: { location: this.form.location },
          });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.subtitle {
  background-color: #f3f3f3;
  border: lightgray 1px solid;
  border-radius: 0.25rem;
  padding: 0.5rem;
  text-align: center;
}
.uniqueImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.leftImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.rightImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 2rem;
  left: 2rem;
}

.comments {
  margin-top: 0.2rem;
  font-style: italic;
}

.gray-text {
  display: block;
  color: gray;
}

.stock {
  white-space: pre-wrap;
  &.available {
    color: green;
  }
  &.unavailable {
    color: red;
  }
}

ol {
  list-style-type: circle;
  li {
    margin-left: 2rem;
  }
}
</style>
